import Citadin from '../../assets/Citadin.jpg';
import Monospace from '../../assets/monospace.jpg';
import SUV from '../../assets/SUV.jpg';
import Utilitaire from '../../assets/utilitaire.jpg';

function HeaderSection3() {
  const categories = [
    {
      title: 'Utilitaire',
      image: Utilitaire,
      description: 'Pour déménager, transporter ou travailler.',
      icon: 'bi-box-seam',
    },
    {
      title: 'SUV',
      image: SUV,
      description: "Plus d'espace pour vos escapades.",
      icon: 'bi-car-front-fill',
    },
    {
      title: 'Citadine',
      image: Citadin,
      description: 'Agile, pratique et idéale en ville.',
      icon: 'bi-buildings',
    },
    {
      title: 'Monospace',
      image: Monospace,
      description: 'Le confort pour voyager ensemble.',
      icon: 'bi-people-fill',
    },
  ];

  return (
    <section className="mc-category-section">
      <div className="container mc-container">
        <div className="mc-section-heading mc-section-heading-row">
          <div>
            <span className="mc-section-kicker">TROUVEZ VOTRE STYLE</span>

            <h2>
              Une voiture pour
              <span>chaque besoin.</span>
            </h2>
          </div>

          <p>
            De la petite citadine au véhicule familial, choisissez le véhicule qui correspond
            réellement à votre trajet.
          </p>
        </div>

        <div className="mc-category-grid">
          {categories.map((category) => (
            <article className="mc-category-card" key={category.title}>
              <img src={category.image} alt={category.title} />

              <div className="mc-category-overlay" />

              <div className="mc-category-icon">
                <i className={`bi ${category.icon}`} />
              </div>

              <div className="mc-category-content">
                <h3>{category.title}</h3>

                <p>{category.description}</p>

                <span className="mc-category-link">
                  Explorer
                  <i className="bi bi-arrow-up-right" />
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HeaderSection3;
